import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import {  useNavigate  } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Hire_bill_report = () => {
  useAuthRedirect();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const storedBranch = localStorage.getItem("branch");
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  const canView  = hasPermission("Hire Bill Generation", "view");
      const canEntry = hasPermission("Hire Bill Generation", "entry");
    

  // Fetch filtered data when branch is selected
  useEffect(() => {
    if (!storedBranch) {
      console.warn("No branch selected.");
      return;
    }

    setLoading(true);
    axios
      .get(`https://rfs2.infraconsoft.net.in/api/hire_bill_listing?branch_code=${storedBranch}`)
      .then((response) => {
        setData(response.data.hireBill);
        setFilteredData(response.data.hireBill);
        // console.log('bill vehicles:',response.data.hireBill );
        
      })
      .catch((error) => {
        console.error("Error fetching vehicles:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [storedBranch]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter(
      (item) =>
        String(item.fld_vno || "").toLowerCase().includes(term) ||
        String(item.fld_vcode || "").toLowerCase().includes(term) ||
        String(item.fld_vname || "").toLowerCase().includes(term)
    );

    setFilteredData(filtered);
  };

  // 🔹 Function to handle bill check before navigation (with console logs)
const handleBillClick = async (vcode, vbasis, fld_vno) => {
  try {
    const url = `https://rfs2.infraconsoft.net.in/api/check_bill_generated/${vcode}`;
    const res = await axios.get(url);

    if (res.data.count > 0) {
      
      Swal.fire({
        icon: "warning",
        title: "Bill Already Generated",
        text: "This vehicle already has a bill waiting for approval.",
      });
    } else {
      navigate(`/generate_bill/${vcode}/${vbasis}`);
    }
  } catch (err) {
    console.error("❌ Error checking bill:", err);
  }
};


if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Hire vehicle list</h2>
          <Time />
        </section>

        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search Here..."
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vehicle Code</th>
                <th>Vehicle Number</th>
                <th>Vehicle Name</th>
                <th>Vehicle Type</th>
                <th>Vehicle Basis</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">
                    Loading data, please wait...
                  </td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
  {canEntry ? (
    <span
      style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
      onClick={() =>
        handleBillClick(item.fld_vcode, item.fld_vbasis, item.fld_equip)
      }
    >
      {item.fld_vcode}
    </span>
  ) : (
    <>{item.fld_vcode}</>
  )}
</td>


                    <td>{item.fld_vno}</td>
                    <td>{item.fld_vname}</td>
                    <td>{item.fld_vtype}</td>
                    <td>{item.fld_vbasis}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>
          <button onClick={() => paginate(1)} className={currentPage === 1 ? "active" : ""}>
            1
          </button>
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map(
              (_, index) => {
                const pageNumber = currentPage + index;
                if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                  return (
                    <button
                      key={pageNumber}
                      onClick={() => paginate(pageNumber)}
                      className={currentPage === pageNumber ? "active" : ""}
                    >
                      {pageNumber}
                    </button>
                  );
                }
                return null;
              }
            )}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hire_bill_report;